import toMap from '~/misc/toMap';
export default toMap([
  'ONE',
  'SEVEN',
  'FIFTEEN',
  'THIRTY'
])


// WEBPACK FOOTER //
// ./src/components/rate/common/dateRange.js